import {
  EPermissionDeviceTypes,
  EPermissionValue,
  TPermissionsInfo,
} from 'shared/types/permission.interface';

export const PERMISSIONS_INFO: TPermissionsInfo = {
  [EPermissionDeviceTypes.Microphone]: {
    [EPermissionValue.Denied]: {
      title: 'Microphone is blocked',
      subtitle: `It looks like you’ve blocked microphone access.
                To continue, please allow permissions in your browser’s settings
                and then turn on your microphone.`,
      icon: 'icon-micro_off',
    },
    [EPermissionValue.Prompt]: {
      title: 'Enable Microphone',
      subtitle: `To join the meeting, please allow access to your microphone in the browser.
              Click “Allow” when prompted above.`,
      icon: 'icon-micro_on',
    },
    [EPermissionValue.Granted]: null,
  },
  [EPermissionDeviceTypes.Camera]: {
    [EPermissionValue.Denied]: {
      title: 'Camera is blocked',
      subtitle: `It looks like you’ve blocked camera access.
                To continue, please allow permissions in your browser’s settings
                and then turn on your camera.`,
      icon: 'icon-camera_off',
    },
    [EPermissionValue.Prompt]: {
      title: 'Enable Camera',
      subtitle: `To join the meeting, please allow access to your camera in your browser.
Click “Allow” when prompted above.`,
      icon: 'icon-camera_on',
    },
    [EPermissionValue.Granted]: null,
  },
};
